import { request } from '@/renderer/utils/api';
import { IS_SERVER } from '@/renderer/utils/ssr';

import type { WallsPost } from '../dataFetcher';

export interface PostData {
  post: WallsPost | null;
}

const abortInit = () =>
  typeof AbortSignal === 'undefined'
    ? {}
    : { signal: AbortSignal.timeout(IS_SERVER ? 2000 : 10000) };

export async function data(pageContext: Vike.PageContext): Promise<PostData> {
  const slug = pageContext.routeParams?.slug;

  if (!slug) {
    return { post: null };
  }

  try {
    const res = await request<{ data: WallsPost }>(
      { input: `/api/v1/posts/${encodeURIComponent(slug)}`, init: abortInit() },
      { skipRefresh: true, cache: { maxAge: 5 * 60 * 1000 } },
    );

    return { post: res?.data ?? null };
  } catch {
    return { post: null };
  }
}
